module.exports = __webpack_public_path__ + "img/hxgz.c41280a4.svg";